import { getUserAssetInfo } from 'config/api';
import {
  isPremium,
  isIosApp,
  isAndroidApp,
} from 'components/features/utils/userStatus';

export const registerDataLayer = async () => {
  getUserAssetInfo().then(ret => {
    const userAssetInfo = {
      assets: ret.Assets?.toString(),
      userBrokers: ret.UserBrokers === null ? '' : ret.UserBrokers.join(','),
      accountTypes: ret.AccountTypes === null ? '' : ret.AccountTypes.join(','),
      positions: ret.Positions === null ? '' : ret.Positions.join(''),
      goals: ret.Goals === null ? '' : ret.Goals.join(','),
    };

    const dataLayer = window.dataLayer || [];
    const userId = ((nullableObj: unknown): string | null => {
      if (typeof nullableObj !== 'object') return null;
      if (nullableObj === null) return null;
      if ('ID' in nullableObj) {
        const obj = nullableObj as { ID: unknown };
        return typeof obj.ID === 'string' ? obj.ID : null;
      }
      return null;
    })(JSON.parse(sessionStorage.getItem('user') ?? '{}'));

    userId &&
      dataLayer.push({
        user_id: userId,
        crm_id: userId,
        is_charged: isPremium(),
        assets: userAssetInfo.assets,
        userBrokers: userAssetInfo.userBrokers,
        accountTypes: userAssetInfo.accountTypes,
        positions: userAssetInfo.positions,
        goals: userAssetInfo.goals,
        platform: isIosApp() ? 'IosApp' : isAndroidApp() ? 'AndroidApp' : 'Web',
      });
  });
};
